import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { urlencoded } from 'express';

import { ProductListResponseDataItem } from 'src/api/models';
import { ProductService } from 'src/api/services/product.service';

import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-main-search',
  templateUrl: './main-search.component.html',
  styleUrls: ['./main-search.component.scss']
})
export class MainSearchComponent implements OnInit {

  @Input() searchText: string;
  searchResult: Array<ProductListResponseDataItem>;

  constructor(private http: HttpClient, public appService: AppService, public productService: ProductService) { }
  search(searchTextEventValue = null) {
    if (searchTextEventValue) {
      this.searchText = searchTextEventValue;
    }
    // const params = {
    //   filters: {
    //     'article][$containsi':  this.searchText,
    //   }
    // }
    // this.productService.getProducts(params).subscribe(data => { 
    //   this.searchResult = data.data;
    // })    

    this.http.get<ProductListResponseDataItem[]>(this.appService.baseUrl + '/api/products/search/' + encodeURIComponent(this.searchText))
      .subscribe(data => {
        this.searchResult = data;
      });
  }
  ngOnInit(): void {
    if (this.searchText) {
      this.search()
    }
  }


}
